import { render } from "./XpCard.vue?vue&type=template&id=75455262&scoped=true"
import script from "./XpCard.vue?vue&type=script&lang=js"
export * from "./XpCard.vue?vue&type=script&lang=js"

import "./XpCard.vue?vue&type=style&index=0&id=75455262&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75455262"]])

export default __exports__